import { marked } from 'marked';
import React from 'react';

import * as Style from './style.module.scss';

interface MarkdownSectionProps {
    markdown: string;
}

const MarkdownSection: React.FC<MarkdownSectionProps> = ({ markdown }) => {
    const htmlContent = React.useMemo(() => {
        return marked.parse(markdown) as string;
    }, [markdown]);

    return (
        <div className={Style.markdownWrapper} dangerouslySetInnerHTML={{ __html: htmlContent }} />
    );
};

export default MarkdownSection;
